export const DEFAULT_AVATAR =
    "https://ui-avatars.com/api/?name=Auto+Transporter&background=0FB9B1&color=fff";

export const appUrl = process.env.EXPO_PUBLIC_API_URL || "";
export const registerUrl =
    process.env.EXPO_PUBLIC_REGISTER_URL ||
    "https://auto-transporter.expo.app/register";
export const ENV = process.env.EXPO_PUBLIC_APP_ENV || "development";
export const isGeofenceEnabled =
    ENV === "production" ||
    process.env.EXPO_PUBLIC_GEOFENCE_ENABLED !== "false";
export const SUPPORT_MAIL = "support@autotransporter.co.uk";
export const SUPPORT_PHONE = "+44 800 229 4472";
export const APP_STORE_URL =
    "https://apps.apple.com/us/app/auto-transporter-uk/id6761536648";
export const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.seacomsoft.autotransporter";